export enum DeviceTypes {
    'MOBILE' = 'MOBILE',
    'TABLET' = 'TABLET',
    'DESKTOP' = 'DESKTOP',
}
